import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ProjectSubmittalLog.css';
import printWhiteSvg from 'images/print-white.svg';
import Button from 'components/shared/button/Button';
import NavigationBar from 'components/shared/navigation/NavigationBar';
import PdfViewer from 'components/shared/pdf-viewer/PdfViewer';
import { Enterprise } from 'domain/enterprise';
import { getCurrentUser } from 'selectors/authentication';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import { getNotifications } from 'selectors/notifications';
import { unreadNotifications } from 'domain/notification';
import { markNotifiableNotificationsAsRead } from 'actions/notifications';
import {
  getSubmittals,
  getTotal,
  getCurrentPage,
  getCurrentStatus,
  getDueDateFilter,
  getPageSize,
  getSubmittalTabSelected,
  getSubmittalLogPdfViewer,
  getSubmittalLogPdf,
} from 'components/admin/projects/details/project-submittal-log/store/selectors';
import {
  initSubmittalLog,
  loadSubmittalsRequest,
  setSubmittalTabSelected,
  initSubmittalModal,
  setSubmittalModalShow,
  openSubmittal,
  setSubmittalLogPdfViewer,
  loadSubmittalLogPdfRequest,
  loadSubmittalLeadTimeLogPdfRequest,
} from 'components/admin/projects/details/project-submittal-log/store/actions';
import SubmittalLogTable from 'components/admin/projects/details/project-submittal-log/SubmittalLogTable';
import SubmittalLeadTimeLogTable from 'components/admin/projects/details/project-submittal-log/SubmittalLeadTimeLogTable';
import SubmittalModalContainer from 'components/admin/projects/details/project-submittal-log/SubmittalModalContainer';

class ProjectSubmittalLog extends Component {
  constructor(props) {
    super(props);

    props.dispatch(initSubmittalLog());
  }

  componentDidMount() {
    if (this.props.currentProject) {
      this.handlePageChange(1, this.defaultStatus());
    }
  }

  handleSubmittalTabSelection = (submittalTab) => {
    this.handlePageChange(1, this.defaultStatus(submittalTab));
    this.props.dispatch(setSubmittalTabSelected(submittalTab));
  };

  handlePageChange = (page, status, dueDateFilter) => {
    const { currentProject, dispatch } = this.props;
    dispatch(
      loadSubmittalsRequest(currentProject.id, page, status, dueDateFilter)
    );
  };

  showPreSubmittal = (contribType) => {
    return Enterprise.spackleOrGc(contribType);
  };

  defaultStatus = (submittalTab = 2) => {
    const { currentProject } = this.props;
    const showPreSubmittal = !!this.showPreSubmittal(
      currentProject.contributor_type
    );
    return submittalTab === 3
      ? 'cls_approved'
      : (showPreSubmittal && (submittalTab === 1 ? 'pre' : 'not_pre')) || 'all';
  };

  handleAddSubmittal = () => {
    this.props.dispatch(initSubmittalModal());
    this.props.dispatch(setSubmittalModalShow(true));
  };

  handleOpenSubmittal = (id) => {
    const { currentUser, currentProject, dispatch } = this.props;
    dispatch(openSubmittal(currentProject.id, id, currentUser));
    dispatch(markNotifiableNotificationsAsRead(id, 'Submittal'));
  };

  handleViewPdf = () => {
    const { currentProject, submittalTabSelected, dispatch } = this.props;
    const promise =
      submittalTabSelected === 3
        ? dispatch(loadSubmittalLeadTimeLogPdfRequest(currentProject.id))
        : dispatch(
            loadSubmittalLogPdfRequest(
              currentProject.id,
              this.defaultStatus(submittalTabSelected)
            )
          );
    promise.then((response) => {
      if (response.ok) {
        dispatch(setSubmittalLogPdfViewer(true));
      }
    });
  };

  handleSubmittalLogPdfViewerClose = () => {
    this.props.dispatch(setSubmittalLogPdfViewer(false));
  };

  render() {
    const {
      currentUser,
      currentProject,
      notifications,
      submittalTabSelected,
      submittals,
      total,
      currentPage,
      currentStatus,
      pageSize,
      submittalLogPdfViewer,
      submittalLogPdf,
      dueDateFilter,
    } = this.props;
    const unreadById = unreadNotifications(notifications, 'Submittal');
    return (
      currentProject && (
        <div className="submittal-log">
          <div className="submittal-log-header">
            <NavigationBar
              items={[
                {
                  id: 1,
                  title: 'P-SUBMITTAL LOG',
                  show: this.showPreSubmittal(currentProject.contributor_type),
                },
                {
                  id: 2,
                  title: 'SUBMITTAL LOG',
                },
                {
                  id: 3,
                  title: 'LEAD TIME LOG',
                },
              ]}
              selectedValue={submittalTabSelected}
              onSelected={this.handleSubmittalTabSelection}
            />
            <div className="buttons-container">
              <Button
                className="button-gray"
                icon={printWhiteSvg}
                label="View PDF"
                onClick={this.handleViewPdf}
              />
              {!Enterprise.primary(currentProject.contributor_type) && (
                <Button
                  className="button-orange"
                  label="Add New Submittal"
                  onClick={this.handleAddSubmittal}
                />
              )}
            </div>
          </div>

          {/*Navigation bar items content*/}
          {submittalTabSelected === 3 ? (
            <SubmittalLeadTimeLogTable
              submittals={submittals}
              total={total}
              currentPage={currentPage}
              currentStatus={currentStatus}
              pageSize={pageSize}
              unreadById={unreadById}
              handlePageChange={this.handlePageChange}
              handleOpenSubmittal={this.handleOpenSubmittal}
            />
          ) : (
            <SubmittalLogTable
              submittals={submittals}
              total={total}
              currentPage={currentPage}
              currentStatus={currentStatus}
              dueDateFilter={dueDateFilter}
              pageSize={pageSize}
              currentUser={currentUser}
              contribType={currentProject.contributor_type}
              unreadById={unreadById}
              submittalTabSelected={submittalTabSelected}
              handlePageChange={this.handlePageChange}
              handleOpenSubmittal={this.handleOpenSubmittal}
            />
          )}

          {submittalLogPdfViewer && (
            <PdfViewer
              content={{
                source: submittalLogPdf,
                type: 'blob',
              }}
              show={submittalLogPdfViewer}
              onClose={this.handleSubmittalLogPdfViewerClose}
            />
          )}

          <SubmittalModalContainer />
        </div>
      )
    );
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    currentProject: getCurrentProject(state),
    total: getTotal(state),
    currentPage: getCurrentPage(state),
    currentStatus: getCurrentStatus(state),
    dueDateFilter: getDueDateFilter(state),
    pageSize: getPageSize(state),
    submittals: getSubmittals(state),
    submittalTabSelected: getSubmittalTabSelected(state),
    notifications: getNotifications(state),
    submittalLogPdfViewer: getSubmittalLogPdfViewer(state),
    submittalLogPdf: getSubmittalLogPdf(state),
  };
})(ProjectSubmittalLog);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-submittal-log/ProjectSubmittalLog.js